/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCartPlus: {
  name: 'cart-plus';
  data: string;
} = {
  name: 'cart-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 .5a.5.5 0 0 1 .5.5v1.5H14a.5.5 0 0 1 0 1h-1.5V5a.5.5 0 0 1-1 0V3.5H10a.5.5 0 0 1 0-1h1.5V1a.5.5 0 0 1 .5-.5Zm-10 3a.5.5 0 0 0 0 1h.22a.5.5 0 0 1 .484.379l1.622 6.485A1.5 1.5 0 0 0 5.78 12.5h4.4a1.5 1.5 0 0 0 1.47-1.206l.6-3a1.5 1.5 0 0 0-1.47-1.794H4.14l-.467-1.864A1.5 1.5 0 0 0 2.22 3.5H2Zm3.296 7.621-.905-3.62h6.39a.5.5 0 0 1 .49.597l-.6 3a.5.5 0 0 1-.49.402h-4.4a.5.5 0 0 1-.485-.379ZM12 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-7 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
